// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"d75d5620cab496f9","297":"c06c63b9729495fe","643":"f24d256660e09565"}[chunkId] + ".js";
};